module.exports = __webpack_public_path__ + "img/set-item4.73dd0c13.png";